import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FilterIcon, SearchIcon, GridIcon, ListIcon } from 'lucide-react';
// Mock product data
const mockProducts = [{
  id: 1,
  name: 'Standard Corrugated Boxes',
  category: 'Boxes',
  supplier: 'BoxMaster Inc.',
  rating: 4.5,
  reviews: 128,
  price: '$0.75 - $2.50',
  moq: '500 units',
  image: 'https://images.unsplash.com/photo-1607344645866-009c320c5ab8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
  description: 'High-quality corrugated boxes suitable for shipping and storage. Available in multiple sizes and strengths.'
}, {
  id: 2,
  name: 'Eco-Friendly Mailers',
  category: 'Mailers',
  supplier: 'Green Packaging Co.',
  rating: 4.8,
  reviews: 96,
  price: '$0.35 - $0.85',
  moq: '1000 units',
  image: 'https://images.unsplash.com/photo-1676299081847-824916254791?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
  description: '100% biodegradable mailer envelopes made from recycled materials. Water-resistant and durable.'
}, {
  id: 3,
  name: 'Custom Printed Tape',
  category: 'Tapes',
  supplier: 'BrandPack Solutions',
  rating: 4.6,
  reviews: 72,
  price: '$3.25 - $5.50',
  moq: '36 rolls',
  image: 'https://images.unsplash.com/photo-1635405074683-96d6921a2a68?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
  description: 'Custom printed packaging tape with your logo and branding. Available in various widths and lengths.'
}, {
  id: 4,
  name: 'Bubble Wrap Rolls',
  category: 'Protective',
  supplier: 'SafePack Inc.',
  rating: 4.3,
  reviews: 54,
  price: '$15.00 - $45.00',
  moq: '10 rolls',
  image: 'https://images.unsplash.com/photo-1626806787461-102c1bfaaea1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
  description: 'High-quality bubble wrap for protecting fragile items during shipping and storage. Available in different bubble sizes.'
}, {
  id: 5,
  name: 'Kraft Paper Gift Bags',
  category: 'Bags',
  supplier: 'Retail Packaging Co.',
  rating: 4.7,
  reviews: 112,
  price: '$0.25 - $1.20',
  moq: '250 units',
  image: 'https://images.unsplash.com/photo-1607465051780-06f0994c681f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
  description: 'Eco-friendly kraft paper gift bags with handles. Perfect for retail and gift packaging.'
}, {
  id: 6,
  name: 'Poly Mailer Bags',
  category: 'Mailers',
  supplier: 'ShipRight Solutions',
  rating: 4.4,
  reviews: 87,
  price: '$0.15 - $0.45',
  moq: '1000 units',
  image: 'https://images.unsplash.com/photo-1620783770629-122b7f187703?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
  description: 'Lightweight, waterproof poly mailer bags for shipping soft goods. Available in multiple sizes and colors.'
}];
// Categories for filtering
const categories = ['All Categories', 'Boxes', 'Mailers', 'Tapes', 'Protective', 'Bags', 'Labels', 'Void Fill'];
export function ProductCatalog() {
  const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'list'
  const [selectedCategory, setSelectedCategory] = useState('All Categories');
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  // Filter products based on category and search query
  const filteredProducts = mockProducts.filter(product => {
    const matchesCategory = selectedCategory === 'All Categories' || product.category === selectedCategory;
    const matchesSearch = product.name.toLowerCase().includes(searchQuery.toLowerCase()) || product.description.toLowerCase().includes(searchQuery.toLowerCase()) || product.supplier.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });
  return <div className="space-y-6" data-id="element-412">
      {/* Page Header */}
      <div className="bg-white rounded-lg shadow p-6" data-id="element-413">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-414">
          <div data-id="element-415">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-416">
              Packaging Products
            </h1>
            <p className="text-gray-500 mt-1" data-id="element-417">
              Browse our selection of quality packaging solutions
            </p>
          </div>
          <div className="mt-4 md:mt-0 flex space-x-2" data-id="element-418">
            <button onClick={() => setViewMode('grid')} className={`p-2 rounded-md ${viewMode === 'grid' ? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-600'}`} data-id="element-419">
              <GridIcon className="h-5 w-5" data-id="element-420" />
            </button>
            <button onClick={() => setViewMode('list')} className={`p-2 rounded-md ${viewMode === 'list' ? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-600'}`} data-id="element-421">
              <ListIcon className="h-5 w-5" data-id="element-422" />
            </button>
            <button onClick={() => setShowFilters(!showFilters)} className="p-2 rounded-md bg-gray-100 text-gray-600 hover:bg-gray-200 md:hidden" data-id="element-423">
              <FilterIcon className="h-5 w-5" data-id="element-424" />
            </button>
          </div>
        </div>
        {/* Search Bar */}
        <div className="mt-6" data-id="element-425">
          <div className="relative" data-id="element-426">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-427">
              <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-428" />
            </div>
            <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="Search products, suppliers, or keywords..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-429" />
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row gap-6" data-id="element-430">
        {/* Filters - Desktop */}
        <div className="hidden md:block w-64 bg-white rounded-lg shadow p-6 h-fit" data-id="element-431">
          <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-432">Filters</h2>
          <div className="space-y-6" data-id="element-433">
            <div data-id="element-434">
              <h3 className="text-sm font-medium text-gray-900 mb-2" data-id="element-435">
                Categories
              </h3>
              <div className="space-y-2" data-id="element-436">
                {categories.map(category => <div key={category} className="flex items-center" data-id="element-437">
                    <input id={`category-${category}`} name="category" type="radio" checked={selectedCategory === category} onChange={() => setSelectedCategory(category)} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" data-id="element-438" />
                    <label htmlFor={`category-${category}`} className="ml-3 text-sm text-gray-700" data-id="element-439">
                      {category}
                    </label>
                  </div>)}
              </div>
            </div>
            <div data-id="element-440">
              <h3 className="text-sm font-medium text-gray-900 mb-2" data-id="element-441">
                Price Range
              </h3>
              <div className="space-y-2" data-id="element-442">
                <div className="flex items-center" data-id="element-443">
                  <input id="price-any" name="price" type="radio" defaultChecked className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" data-id="element-444" />
                  <label htmlFor="price-any" className="ml-3 text-sm text-gray-700" data-id="element-445">
                    Any price
                  </label>
                </div>
                <div className="flex items-center" data-id="element-446">
                  <input id="price-low" name="price" type="radio" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" data-id="element-447" />
                  <label htmlFor="price-low" className="ml-3 text-sm text-gray-700" data-id="element-448">
                    $0 - $1.00
                  </label>
                </div>
                <div className="flex items-center" data-id="element-449">
                  <input id="price-mid" name="price" type="radio" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" data-id="element-450" />
                  <label htmlFor="price-mid" className="ml-3 text-sm text-gray-700" data-id="element-451">
                    $1.00 - $5.00
                  </label>
                </div>
                <div className="flex items-center" data-id="element-452">
                  <input id="price-high" name="price" type="radio" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" data-id="element-453" />
                  <label htmlFor="price-high" className="ml-3 text-sm text-gray-700" data-id="element-454">
                    $5.00+
                  </label>
                </div>
              </div>
            </div>
            <div data-id="element-455">
              <h3 className="text-sm font-medium text-gray-900 mb-2" data-id="element-456">
                Minimum Order
              </h3>
              <div className="space-y-2" data-id="element-457">
                <div className="flex items-center" data-id="element-458">
                  <input id="moq-any" name="moq" type="radio" defaultChecked className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" data-id="element-459" />
                  <label htmlFor="moq-any" className="ml-3 text-sm text-gray-700" data-id="element-460">
                    Any quantity
                  </label>
                </div>
                <div className="flex items-center" data-id="element-461">
                  <input id="moq-low" name="moq" type="radio" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" data-id="element-462" />
                  <label htmlFor="moq-low" className="ml-3 text-sm text-gray-700" data-id="element-463">
                    Under 500
                  </label>
                </div>
                <div className="flex items-center" data-id="element-464">
                  <input id="moq-mid" name="moq" type="radio" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" data-id="element-465" />
                  <label htmlFor="moq-mid" className="ml-3 text-sm text-gray-700" data-id="element-466">
                    500 - 1000
                  </label>
                </div>
                <div className="flex items-center" data-id="element-467">
                  <input id="moq-high" name="moq" type="radio" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" data-id="element-468" />
                  <label htmlFor="moq-high" className="ml-3 text-sm text-gray-700" data-id="element-469">
                    1000+
                  </label>
                </div>
              </div>
            </div>
            <div data-id="element-470">
              <h3 className="text-sm font-medium text-gray-900 mb-2" data-id="element-471">
                Supplier Rating
              </h3>
              <div className="space-y-2" data-id="element-472">
                <div className="flex items-center" data-id="element-473">
                  <input id="rating-any" name="rating" type="radio" defaultChecked className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" data-id="element-474" />
                  <label htmlFor="rating-any" className="ml-3 text-sm text-gray-700" data-id="element-475">
                    Any rating
                  </label>
                </div>
                <div className="flex items-center" data-id="element-476">
                  <input id="rating-4plus" name="rating" type="radio" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" data-id="element-477" />
                  <label htmlFor="rating-4plus" className="ml-3 text-sm text-gray-700" data-id="element-478">
                    4★ & above
                  </label>
                </div>
                <div className="flex items-center" data-id="element-479">
                  <input id="rating-3plus" name="rating" type="radio" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" data-id="element-480" />
                  <label htmlFor="rating-3plus" className="ml-3 text-sm text-gray-700" data-id="element-481">
                    3★ & above
                  </label>
                </div>
              </div>
            </div>
            <button className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-482">
              Apply Filters
            </button>
          </div>
        </div>
        {/* Filters - Mobile (Slide-in panel) */}
        {showFilters && <div className="md:hidden fixed inset-0 bg-gray-500 bg-opacity-75 z-50 flex" data-id="element-483">
            <div className="relative bg-white w-80 max-w-full h-full ml-auto p-6 overflow-y-auto" data-id="element-484">
              <div className="flex justify-between items-center mb-6" data-id="element-485">
                <h2 className="text-lg font-medium text-gray-900" data-id="element-486">Filters</h2>
                <button onClick={() => setShowFilters(false)} className="text-gray-500 hover:text-gray-700" data-id="element-487">
                  <XIcon className="h-5 w-5" data-id="element-488" />
                </button>
              </div>
              <div className="space-y-6" data-id="element-489">
                <div data-id="element-490">
                  <h3 className="text-sm font-medium text-gray-900 mb-2" data-id="element-491">
                    Categories
                  </h3>
                  <div className="space-y-2" data-id="element-492">
                    {categories.map(category => <div key={category} className="flex items-center" data-id="element-493">
                        <input id={`mobile-category-${category}`} name="mobile-category" type="radio" checked={selectedCategory === category} onChange={() => setSelectedCategory(category)} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" data-id="element-494" />
                        <label htmlFor={`mobile-category-${category}`} className="ml-3 text-sm text-gray-700" data-id="element-495">
                          {category}
                        </label>
                      </div>)}
                  </div>
                </div>
                {/* Additional mobile filters (same as desktop) */}
                {/* ... */}
                <div className="mt-8 flex space-x-4" data-id="element-496">
                  <button onClick={() => setShowFilters(false)} className="flex-1 bg-gray-200 text-gray-800 py-2 px-4 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2" data-id="element-497">
                    Cancel
                  </button>
                  <button onClick={() => setShowFilters(false)} className="flex-1 bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-498">
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>}
        {/* Product Grid/List */}
        <div className="flex-1" data-id="element-499">
          {filteredProducts.length === 0 ? <div className="bg-white rounded-lg shadow p-8 text-center" data-id="element-500">
              <p className="text-gray-500 text-lg" data-id="element-501">
                No products match your search criteria.
              </p>
              <button onClick={() => {
            setSelectedCategory('All Categories');
            setSearchQuery('');
          }} className="mt-4 text-blue-600 hover:text-blue-800 font-medium" data-id="element-502">
                Clear all filters
              </button>
            </div> : viewMode === 'grid' ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-503">
              {filteredProducts.map(product => <Link key={product.id} to={`/products/${product.id}`} className="bg-white rounded-lg shadow overflow-hidden hover:shadow-md transition-shadow duration-300" data-id="element-504">
                  <div className="h-48 overflow-hidden" data-id="element-505">
                    <img src={product.image} alt={product.name} className="w-full h-full object-cover" data-id="element-506" />
                  </div>
                  <div className="p-4" data-id="element-507">
                    <div className="text-xs font-medium text-blue-600 uppercase tracking-wide" data-id="element-508">
                      {product.category}
                    </div>
                    <h3 className="mt-1 text-lg font-medium text-gray-900" data-id="element-509">
                      {product.name}
                    </h3>
                    <p className="mt-1 text-sm text-gray-500" data-id="element-510">
                      {product.supplier}
                    </p>
                    <div className="mt-2 flex items-center" data-id="element-511">
                      <div className="flex items-center" data-id="element-512">
                        {[...Array(5)].map((_, i) => <svg key={i} className={`h-4 w-4 ${i < Math.floor(product.rating) ? 'text-yellow-400' : i < product.rating ? 'text-yellow-300' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-513">
                            <path fillRule="evenodd" d="M10 15.585l-5.196 2.73 1-5.82-4.196-4.073 5.8-.844L10 2.979l2.592 5.26 5.8.844-4.196 4.073 1 5.82z" clipRule="evenodd" data-id="element-514" />
                          </svg>)}
                      </div>
                      <p className="ml-2 text-sm text-gray-500" data-id="element-515">
                        {product.reviews} reviews
                      </p>
                    </div>
                    <div className="mt-2 flex justify-between items-center" data-id="element-516">
                      <p className="text-sm font-medium text-gray-900" data-id="element-517">
                        {product.price}
                      </p>
                      <p className="text-sm text-gray-500" data-id="element-518">
                        MOQ: {product.moq}
                      </p>
                    </div>
                  </div>
                </Link>)}
            </div> : <div className="space-y-4" data-id="element-519">
              {filteredProducts.map(product => <Link key={product.id} to={`/products/${product.id}`} className="bg-white rounded-lg shadow overflow-hidden flex hover:shadow-md transition-shadow duration-300" data-id="element-520">
                  <div className="w-32 h-32 flex-shrink-0" data-id="element-521">
                    <img src={product.image} alt={product.name} className="w-full h-full object-cover" data-id="element-522" />
                  </div>
                  <div className="p-4 flex-1" data-id="element-523">
                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start" data-id="element-524">
                      <div data-id="element-525">
                        <div className="text-xs font-medium text-blue-600 uppercase tracking-wide" data-id="element-526">
                          {product.category}
                        </div>
                        <h3 className="mt-1 text-lg font-medium text-gray-900" data-id="element-527">
                          {product.name}
                        </h3>
                        <p className="mt-1 text-sm text-gray-500" data-id="element-528">
                          {product.supplier}
                        </p>
                      </div>
                      <div className="mt-2 sm:mt-0 sm:ml-4" data-id="element-529">
                        <p className="text-sm font-medium text-gray-900" data-id="element-530">
                          {product.price}
                        </p>
                        <p className="text-sm text-gray-500" data-id="element-531">
                          MOQ: {product.moq}
                        </p>
                      </div>
                    </div>
                    <div className="mt-2 flex items-center" data-id="element-532">
                      <div className="flex items-center" data-id="element-533">
                        {[...Array(5)].map((_, i) => <svg key={i} className={`h-4 w-4 ${i < Math.floor(product.rating) ? 'text-yellow-400' : i < product.rating ? 'text-yellow-300' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-534">
                            <path fillRule="evenodd" d="M10 15.585l-5.196 2.73 1-5.82-4.196-4.073 5.8-.844L10 2.979l2.592 5.26 5.8.844-4.196 4.073 1 5.82z" clipRule="evenodd" data-id="element-535" />
                          </svg>)}
                      </div>
                      <p className="ml-2 text-sm text-gray-500" data-id="element-536">
                        {product.reviews} reviews
                      </p>
                    </div>
                    <p className="mt-2 text-sm text-gray-500 line-clamp-2" data-id="element-537">
                      {product.description}
                    </p>
                  </div>
                </Link>)}
            </div>}
          {/* Pagination */}
          <div className="mt-6 flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6 rounded-lg shadow" data-id="element-538">
            <div className="flex flex-1 justify-between sm:hidden" data-id="element-539">
              <a href="#" className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-540">
                Previous
              </a>
              <a href="#" className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-541">
                Next
              </a>
            </div>
            <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between" data-id="element-542">
              <div data-id="element-543">
                <p className="text-sm text-gray-700" data-id="element-544">
                  Showing <span className="font-medium" data-id="element-545">1</span> to{' '}
                  <span className="font-medium" data-id="element-546">6</span> of{' '}
                  <span className="font-medium" data-id="element-547">24</span> results
                </p>
              </div>
              <div data-id="element-548">
                <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination" data-id="element-549">
                  <a href="#" className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0" data-id="element-550">
                    <span className="sr-only" data-id="element-551">Previous</span>
                    <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-552">
                      <path fillRule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clipRule="evenodd" data-id="element-553" />
                    </svg>
                  </a>
                  <a href="#" aria-current="page" className="relative z-10 inline-flex items-center bg-blue-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600" data-id="element-554">
                    1
                  </a>
                  <a href="#" className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0" data-id="element-555">
                    2
                  </a>
                  <a href="#" className="relative hidden items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 md:inline-flex" data-id="element-556">
                    3
                  </a>
                  <span className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300 focus:outline-offset-0" data-id="element-557">
                    ...
                  </span>
                  <a href="#" className="relative hidden items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 md:inline-flex" data-id="element-558">
                    4
                  </a>
                  <a href="#" className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0" data-id="element-559">
                    <span className="sr-only" data-id="element-560">Next</span>
                    <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-561">
                      <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd" data-id="element-562" />
                    </svg>
                  </a>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}